import { InjectionToken } from '@angular/core';

import { AppEnvironment } from '../models/environment.model';

export const APP_ENVIRONMENT = new InjectionToken<AppEnvironment>('AppEnvironment');
